import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-transaction-type-buy",
  // imports: [],
  templateUrl: "./transaction-type-buy.component.html",
  styleUrl: "./transaction-type-buy.component.css",
  standalone: false,
})
export class TransactionTypeBuyComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
